import { message } from 'antd';
// 默认prefixCls
message.config({ prefixCls: 'oss-ui-message' });
export default message;
